import { Container } from "@mui/material";
import React from "react";
import "./css/PP.css";
export default function Privacy() {
  return (
    <div>
      <Container style={{ padding: "10px", width: "100%" }}>
        <h1 style={{ color: "blue" }}> Processing Purposes</h1>
        <p style={{ fontFamily: "serif", fontWeight: "20rem" }}>
          React processes personal data of the following categories: Identified
          third party infringers of intellectual property rights of our members
          (hereafter: infringers), i.e. name, address, email address, company
          details. React does not process date of birth, social security numbers
          or bank account numbers of infringers.F
        </p>
        <p style={{ fontFamily: "serif", fontWeight: "20rem" }}>
          Data Subjects React processes personal data of the following
          categories: Identified third party infringers of intellectual property
          rights of our members (hereafter: infringers), i.e. name, address,
          email address, company details. React does not process date of birth,
          social security numbers or bank account numbers of infringers.
          Employees. This data contains names, addresses, email addresses, birth
          days, social security numbers and bank accounts numbers. Partners
          (partner offices, associated law offices). This data contains names,
          addresses and email addresses.
        </p>
        <p style={{ fontFamily: "Georgia, serif" }}>
          Authorities (e.g. Police, Customs, Federal Public Service). This data
          contains names, addresses and email addresses. Members of React. This
          data contains names, addresses and email addresses. Job applicants.
          This data contains names, addresses, email addresses and date of
          births.
        </p>
        <div>
          <h1 style={{ color: "blue" }}>Security Breach</h1>
          <p style={{ fontFamily: "math" }}>
            Our computers and software are secured in accordance with standard
            business security practice. Our employees are trained to use data in
            compliance with our Data Use Policy.
          </p>
        </div>
        <div className="malware-privacy">
          <h1 style={{ color: "blue" }}>Breach of Data</h1>
          <p style={{ fontFamily: "emoji" }}>
            In case of a breach of personal data, React’s Privacy Officer will
            notify the local data authorities within 72 hours after having
            become aware of it.
          </p>
        </div>
      </Container>
    </div>
  );
}
